import React from 'react';
import {
  Flex,
  useColorMode,
  useIsMobileView,
  Text,
  color,
  typography,
  CheckFillSvg,
} from 'deepstash-ui';
import NextImage from 'src/components/image/NextImage';

const TITLE = "What you'll learn";

const FALLBACK_SKILLS = [
  'How to prioritize tasks effectively',
  'How to minimize distractions',
  'How to optimize your work environment',
  'How to use technology to your advantage',
  'How to delegate tasks efficiently',
];

interface CollectionSkillsSectionProps {
  skills?: string[];
}

const CollectionSkillsSection: React.FC<CollectionSkillsSectionProps> = ({
  skills,
}) => {
  const isMobileView = useIsMobileView();
  const { colorMode } = useColorMode();

  const finalSkills = React.useMemo(() => {
    return skills !== undefined ? skills : FALLBACK_SKILLS;
  }, [skills]);

  const renderSkill = ({ skill, index }: { skill: string; index: number }) => {
    return (
      <Flex
        key={`skill-${index}`}
        flexDirection="row"
        alignItems="flex-start"
        gridColumnGap={4}
      >
        <CheckFillSvg
          color={'green'}
          boxSize={isMobileView ? '28px' : '34px'}
        />
        <Text
          {...(isMobileView
            ? typography.primaryHeadingFonts.small.regular
            : typography.primaryHeadingFonts.medium.regular)}
          color={color[colorMode].textSecondary}
          flex={1}
        >
          {skill}
        </Text>
      </Flex>
    );
  };

  return (
    <Flex
      flexDirection={isMobileView ? 'column' : 'row'}
      width={'100%'}
      gridColumnGap={64}
      alignItems="center"
    >
      <Flex
        flexDirection="column"
        {...(isMobileView ? { alignItems: 'center' } : { flex: 1.2 })}
      >
        <Text
          {...(isMobileView
            ? typography.primaryHeadingFonts.large.bold
            : typography.primaryHeadingFonts.xl.bold)}
          color={color[colorMode].text}
          textAlign={isMobileView ? 'center' : 'start'}
        >
          {TITLE}
        </Text>
        <Flex
          flexDirection="column"
          gridRowGap={16}
          mt={24}
          {...(isMobileView ? { width: '100%' } : {})}
        >
          {finalSkills.map((skill, index) => {
            return renderSkill({ skill, index });
          })}
        </Flex>
      </Flex>
      <Flex {...(isMobileView ? { mt: 32 } : { flex: 1 })}>
        <NextImage
          wrapperStyle={{
            width: isMobileView ? 300 : 500,
            height: isMobileView ? 250 : 408,
            pointerEvents: 'none',
          }}
          objectFit="contain"
          imageUrl={'https://static.deepstash.com/phone-landing-image.png'}
        />
      </Flex>
    </Flex>
  );
};

export default CollectionSkillsSection;
